import React, { useEffect, useState } from "react";
import Footer_menu from "../../component/footer_menu";
import BillStyle from "./Billing.module.css";
import { useNavigate } from "react-router-dom"
import getFetchConfig from '../../utils/getFetchConfig';
import handleFetchErrors from '../../utils/handleFetchErrors';
import visa from '../../assest/images/visa 1.png'
import appURLs from "../../appURL";
const fetchConfig = getFetchConfig();

export default function Billing_info() {
  const appURL = appURLs();
  const navigate = useNavigate();
  const [loginSource, updateLoginSource] = useState(false);
  const [billingInfo, setBillingInfo] = useState([]);

  useEffect(() => {
    var x = localStorage.getItem("token");
    if (!x) navigate("/")
    const source = localStorage.getItem(`source`);
    if (source) updateLoginSource(true)
    else updateLoginSource(false)
  }, [])

  const fetchBillingInfo = () => {
    fetch(`${appURL}/posts/payment/billing-information`, {
      ...fetchConfig,
      method: `GET`,

    })
      .then(handleFetchErrors)
      .then((sellerAccountJOSNReponse) => {

        setBillingInfo(sellerAccountJOSNReponse.paymentMethods.data)
      
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const deleteCard = (cardId) => {
    fetch(`${appURL}/posts/payment/detach-card`, {
      ...fetchConfig,
      method: "POST",
      body: JSON.stringify({ cardId }),
      headers: {
        "Content-Type": "application/json"
      }
    })
      .then((response) => {
        if (response.ok) {
          setBillingInfo((prevBillingInfo) =>
            prevBillingInfo.filter((method) => method.id !== cardId)
          );
        } else {
          console.log("Error deleting card");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const backToHome = () => {
    window.location.href = "/";
  }

  useEffect(() => {
    fetchBillingInfo();
    deleteCard();
  }, []);

  return (
    <>
      <div className="billing-wrapper-sec" onClick={backToHome}>
        <i className="fa-solid fa-arrow-left"></i>
      </div>
      <div className={BillStyle.Billing}>
        <div className={BillStyle.mainContent}>
          <h3>Billing Information</h3>
          <p>CARDS</p>
        </div>
        {billingInfo && billingInfo.length > 0 ? (
          billingInfo.filter((method) => method && method.card).map((method) => (
            <div key={method.id} className={BillStyle.BillBox}>
              <div className={BillStyle.BilLeft}>
                <div className={BillStyle.BillImage}>
                  <img src={visa} alt="Visa Image" />
                </div>
                <div className={BillStyle.BillContent}>
                  <h3 className={BillStyle.cardName}>
                    {method.card.brand}
                  </h3>
                  <p className={BillStyle.cardName1}>
                    ...{method.card.last4}
                  </p>
                </div>
              </div>
              <div className={BillStyle.BillRemove}>
                <h4 onClick={() => deleteCard(method.id)}>Remove</h4>
              </div>
            </div>
          ))
        ) : (
          <h4 className={BillStyle.ErrorMessage}>No data available</h4>
        )}
      </div>
    </>
  )
}